export class Promo {
  promoName: string | undefined;
  promoCode: string | undefined;
  promoDiscountedAmount: number | undefined;
  promoFinancedAmount: number | undefined;
  pdpLabel: string | undefined;
  bannerLabel: string | undefined;
  priceTemplate: string | undefined;
  price: number | undefined;

  constructor(props: any) {
    if (!props) return;

    this.promoName = props.promoName;
    this.promoCode = props.promoCode;
    this.promoDiscountedAmount = props.promoDiscountedAmount;
    this.promoFinancedAmount = props.promoFinancedAmount;
    this.pdpLabel = props.pdpLabel;
    this.bannerLabel = props.bannerLabel;
    this.priceTemplate = props.priceTemplate;
    this.price = props.price;
  }
}

export default Promo;
